module.exports = __webpack_public_path__ + "img/model_y_selection.b28aaa5d.jpg";